<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
export default {
  computed: {
    links () {
      return this.$router.options.routes
    },
    props () {
      return this.$store.state.app['navigation']
    }
  },
  data () {
    return {
      active: false,
      scrolled: false,
      phones: false
    }
  },
  methods: {
    activate () {
      this.active ? this.active = false : this.active = true
      document.getElementsByTagName('body')[0].classList.toggle('body-stop')
    },
    scroll ({going, direction}) {
      if (going === 'out' && direction === 'top') {
        this.scrolled = true
      }
      if (going === 'in' && direction === 'bottom') {
        this.scrolled = false
      }
    },
    showPhones () {
      this.phones ? this.phones = false : this.phones = true
      window.addEventListener('scroll', this.close)
    },
    close () {
      this.phones = false
    },
    callGa: function (i) {
      if (i === 0) {
        this.$router.push('/')
        setTimeout(() => {
          this.$scrollTo('#home')
        },
        100)
      }
      if (i === 1) {
        this.$router.push('/')
        setTimeout(() => {
          this.$scrollTo('#welcome')
        },
        100)
      }
      if (i === 2) {
        this.$router.push('/')
        setTimeout(() => {
          this.$scrollTo('#about')
        },
        100)
      }
      if (i === 3) {
        this.$router.push('/')
        setTimeout(() => {
          this.$scrollTo('#new-patients')
        },
        100)
      }
      if (i === 4) {
        this.$router.push('/')
        setTimeout(() => {
          this.$scrollTo('#treatments')
        },
        100)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/navigation-desktop/navigation-desktop.vue